import type { Bootstrap } from '@vmos2/core';
import { changeLanguage, getDateFnsLocaleModule } from '@vmos2/core';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDateFnsLocale } from './useDateFnsLocale';

export const useLocale = (
  config: { bootstrap?: Bootstrap },
  settings: { kioskPermanentFooter?: { languageSelector?: string }, localeSwitcher?: boolean }
) => {
  const locales = config.bootstrap?.locales || [];
  const { kioskPermanentFooter, localeSwitcher } = settings;
  const { i18n } = useTranslation();
  const selectedLocale = i18n.language;
  const dateFnsLocale = useDateFnsLocale(selectedLocale);

  const getDateFnsLocale = useCallback(
    () => getDateFnsLocaleModule(selectedLocale).then(module => module?.default),
    [selectedLocale]
  );

  return {
    changeLocale: changeLanguage,
    dateFnsLocale,
    getDateFnsLocale,
    isLocaleSwitcherEnabled: localeSwitcher,
    kioskPermanentFooterLanguageSelector: kioskPermanentFooter?.languageSelector,
    locale: selectedLocale,
    locales,
  };
};
